import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import NotebookPage from './NotebookPage';
import {
  loadClassDetail,
  loadCourseAssemblage,
  getClassDetailStatus,
  getCourseAssemblageStatus,
  getPrevAndNextLessonIds,
  getStudentName,
  getPrevAndNextStudentProfileIds,
} from 'edrolo/domains/bySchoolClass';

import {
  getLessonByLessonId,
  getLessonStatusByLessonId,
  loadLessonByLessonId,
} from 'edrolo/domains/lessons';
import { useProfile, profileUtils } from 'edrolo/domains/profile';
import { NotebookIndex } from '../../types/Notebook';

export default ({
  classId,
  lessonId,
  profileId,
  children,
  ...restProps
}: NotebookIndex) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const classCode = useSelector((state: any) =>
    state.bySchoolClass.getIn(['classDetail', `${classId}`, 'data', 'title'])
  );
  const classDetailStatus = useSelector((state) =>
    getClassDetailStatus(state, classId)
  );
  const courseAssemblageStatus = useSelector((state) =>
    getCourseAssemblageStatus(state, classId)
  );
  const lesson = useSelector((state) => getLessonByLessonId(state, lessonId));
  const lessonStatus = useSelector((state) =>
    getLessonStatusByLessonId(state, lessonId)
  );

  const prevAndNextLessonIds = useSelector((state) =>
    getPrevAndNextLessonIds(state, classId, lessonId)
  );

  const { profile } = useProfile(!!'immutable');
  const isTeacherView = profileUtils.isOverseerOfClass(profile, classId);

  const currentStudentName = useSelector((state) =>
    getStudentName(state, classId, profileId)
  );

  const prevAndNextStudentProfileIds = useSelector((state) =>
    getPrevAndNextStudentProfileIds(state, classId, profileId)
  );

  const dispatch = useDispatch();

  const loadClassDetailCallback = useCallback(
    (classId: ClassId) => dispatch(loadClassDetail.signal(classId)),
    [dispatch]
  );
  const loadCourseAssemblageCallback = useCallback(
    (classId: ClassId) => dispatch(loadCourseAssemblage.signal(classId)),
    [dispatch]
  );
  const loadLessonCallback = useCallback(
    (lessonId: string) => dispatch(loadLessonByLessonId.signal(lessonId)),
    [dispatch]
  );

  return (
    <NotebookPage
      classId={classId}
      lessonId={lessonId}
      profileId={profileId}
      classCode={classCode}
      classDetailStatus={classDetailStatus}
      courseAssemblageStatus={courseAssemblageStatus}
      lesson={lesson}
      lessonStatus={lessonStatus}
      prevAndNextLessonIds={prevAndNextLessonIds}
      loadClassDetail={loadClassDetailCallback}
      loadCourseAssemblage={loadCourseAssemblageCallback}
      loadLesson={loadLessonCallback}
      isTeacherView={isTeacherView}
      currentStudentName={currentStudentName}
      prevAndNextStudentProfileIds={prevAndNextStudentProfileIds}
      {...restProps}
    />
  );
};
